import { Button } from '@/components/ui-kit/button';
import { ArrowLeft, Building2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const OrgNotFoundPage = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex items-center justify-center bg-linear-to-b from-[hsl(var(--gradient-light-from))] to-[hsl(var(--gradient-light-to))]">
      <div className="text-center max-w-md mx-auto px-4">
        <div className="flex justify-center mb-6">
          <div className="p-4 rounded-full bg-[hsl(var(--globe-grey))]/10">
            <Building2 className="h-12 w-12 text-globe-grey" />
          </div>
        </div>

        <h1 className="text-2xl font-bold text-[hsl(var(--fg))] font-heading mb-2">
          {t('ORG_NOTFOUND_TITLE', 'Organization Not Found')}
        </h1>

        <p className="text-globe-grey mb-6">
          {t(
            'ORG_NOTFOUND_DESCRIPTION',
            'The organization you are looking for does not exist or has been removed.'
          )}
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button asChild variant="outline">
            <Link to="/">
              <ArrowLeft className="h-4 w-4 mr-2" />
              {t('ORG_NOTFOUND_GOHOME', 'Go Home')}
            </Link>
          </Button>
          <Button asChild>
            <Link to="/org/new">{t('ORG_NOTFOUND_CREATEORG', 'Create Organization')}</Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default OrgNotFoundPage;
